import type { INpdbConfiguration } from '$shared/interfaces/api/INpdbConfiguration';
import { NpdbConfiguration } from '$shared/models/NpdbConfiguration';
import { Settings } from '$shared/constants/Settings';

export class SettingsFactory {
  static get<T>(key: Settings, data: unknown): T | undefined {
    if (data === null || data === undefined) return data as T | undefined;

    if (key === Settings.NpdbConfigurationSegments) {
      return NpdbConfiguration.from(data as Record<string, INpdbConfiguration>) as T;
    }

    return data as T | undefined;
  }
}
